import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Monetization } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import DateFilter from '../../molecules/DateFilter';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';

export interface CostSummaryProps {
  costSections: any[];
  incurredStartDate?: string;
  incurredEndDate?: string;
  paidStartDate?: string;
  paidEndDate?: string;
}

const useStyles = makeStyles()({
  costContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px 23px 15px 48px',
    backgroundColor: '#F4FFFB',
    borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    gap: '10px',
    height: '40px',
  },
  costInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  dateBox: {
    padding: '6px 12px',
    fontSize: '14px',
    fontWeight: 500,
    borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
  },
  costContainerItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  constContainerList: {
    display: 'flex',
    gap: '10px',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    flexWrap: 'wrap',
  },
});

const CostSummary: React.FC<CostSummaryProps> = ({
  costSections,
  incurredStartDate,
  incurredEndDate,
  paidStartDate,
  paidEndDate,
}) => {
  const { classes } = useStyles();
  const showDateFilter = Boolean(
    incurredStartDate || incurredEndDate || paidStartDate || paidEndDate,
  );
  return (
    <Grid className={classes.costContainer}>
      {showDateFilter && (
        <Grid className={classes.costInnerContainer}>
          <Monetization />
          <Grid className={classes.dateBox}>
            <DateFilter />
          </Grid>
        </Grid>
      )}
      {costSections.map((section, sectionIndex) => (
        <Grid key={sectionIndex}>
          {sectionIndex === 0 ? (
            section.map((item: any, itemIndex: any) => (
              <Grid key={itemIndex} className={classes.costContainerItem}>
                <Typography
                  fontSize="12px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                >
                  {item?.label}
                </Typography>
                <Typography
                  fontSize="14px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                >
                  <span style={{ color: '#000' }}>{item.value}</span>
                  {item?.subvalue && (
                    <span
                      style={{
                        fontSize: '12px',
                        color: patientAccessTheme.palette.text.highemphasis,
                      }}
                    >
                      {item?.subvalue}
                    </span>
                  )}
                </Typography>
              </Grid>
            ))
          ) : (
            <ul className={classes.constContainerList}>
              {section?.map((item: any, itemIndex: any) => (
                <li key={itemIndex}>
                  <Grid className={classes.costContainerItem}>
                    <Typography align="center" fontSize="10px">
                      •
                    </Typography>
                    <Typography
                      fontSize="12px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                    >
                      {item.label}
                    </Typography>
                    <Typography fontSize="14px" textColor="#000">
                      {item.value}
                    </Typography>
                  </Grid>
                </li>
              ))}
            </ul>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default CostSummary;
